import { useMemo } from 'react';
import reverse from 'lodash/reverse';

import { CategoryID } from '../../../../../../categories/categoriesTypes';
import { FetchProductCategoriesQueryResponse } from '../../../../../../products/queries/fetchProductCategories.query';

import { ThreeDStockBreadcrumbsItemType } from '../../components/ThreeDStockBreadcrumbsItem';

interface ThreeDStockMaterialsCategoriesOptions {
  currentCategoryId?: CategoryID;
  categories?: FetchProductCategoriesQueryResponse[];
}

function useThreeDStockBreadcrumbs({
  currentCategoryId,
  categories
}: ThreeDStockMaterialsCategoriesOptions) {
  const breadcrumbs = useMemo<ThreeDStockBreadcrumbsItemType[]>(() => {
    const allCategories: ThreeDStockBreadcrumbsItemType[] = [];

    if (currentCategoryId) {
      const currentCategory = categories?.find(
        (category) => category.id === currentCategoryId
      );

      if (currentCategory) {
        allCategories.push(currentCategory);

        let parentCategory = categories?.find(
          (category) => category.id === currentCategory?.parent?.id
        );

        while (parentCategory) {
          allCategories.push(parentCategory);
          parentCategory = categories?.find(
            (category) => category.id === parentCategory?.parent?.id
          );
        }
      }
    }

    return reverse(allCategories);
  }, [currentCategoryId, categories]);

  return {
    breadcrumbs
  };
}

export default useThreeDStockBreadcrumbs;
